export function getSignUpPayload(values: any) {
	const {
		customerName,
		mobileNumber,
		state,
		district,
		town,
		pincode,
		address_1,
		address_2,
		isCompany,
		businessName,
		// isGstCompliant,
		// gstNumber,
		// billingAddress,
		// machines,
		preferredDRP,
		// partsPurchaser,
		// purchaseMode,
		// purchaseFrequency,
		// commonParts,
		// monthlySpend,
		// ageGroup,
		// preferredLanguage,
		// machinePlans,
		// interestedInFinance,
		// preferredServiceChannel,
		// partsUsagePreference,
		// optInForOffers,
		// preferredContactTime,
		// nearestLandmark,
		// deliveryAvailability,
		// referredBy,
		// npsScore,
		// usesWhatsApp,
		// interestedInAppDemo,
	} = values || {};

	return {
		name: customerName,
		telephone: '+91' + mobileNumber,
		stateId: state,
		districtId: district,
		cityId: town,
		pinCode: pincode,
		address_1: address_1,
		address_2: address_2,
		registeringAsCompany: isCompany,
		businessName: businessName,
		preferredDrp: [preferredDRP],
	};

	// return {
	// 	contactDetails: {
	// 		name: customerName,
	// 		telephone: '+91' + mobileNumber,
	// 		stateId: state,
	// 		districtId: district,
	// 		cityId: town,
	// 		pinCode: pincode,
	// 		address: address,
	// 	},
	// 	companyDetails: {
	// 		registeringAsCompany: isCompany,
	// 		businessName: businessName,
	// 		gstCompliant: isGstCompliant,
	// 		gstNumber: gstNumber,
	// 		billingAddress: billingAddress,
	// 	},
	// 	machines: {
	// 		numberOfMachines: machines.length,
	// 		machines: machines.map((machine) => ({
	// 			machineBrandId: machine.machineBrand,
	// 			modelId: machine.model,
	// 			manufacturedYear: machine.yearOfManufacture,
	// 			hoursRun: machine.hoursRun,
	// 		})),
	// 	},
	// 	purchasingHabits: {
	// 		preferredDrp: [preferredDRP],
	// 		buyerType: partsPurchaser,
	// 		modeOfPurchase: purchaseMode,
	// 		frequencyOfPartsPurchase: purchaseFrequency,
	// 		commonlyPurchasedPartsCategories: commonParts,
	// 		averageSpendOnPartsPerMonth: monthlySpend,
	// 	},
	// 	additionalProfile: {
	// 		ageGroup: ageGroup,
	// 		preferredLanguageForCommunication: preferredLanguage,
	// 		plansToBuySellMachines: machinePlans,
	// 		interestedInFinanceInsuranceProducts: interestedInFinance,
	// 		preferredServiceChannel: preferredServiceChannel,
	// 		partsUsagePreference: partsUsagePreference,
	// 		optInForOffersProductUpdates: optInForOffers,
	// 		preferredContactTime: preferredContactTime,
	// 		nearestLandmark: nearestLandmark,
	// 		availabilityForDeliveryService: deliveryAvailability,
	// 		referredBy: referredBy,
	// 		npsScore: npsScore,
	// 		digitalUsage: usesWhatsApp,
	// 		interestedInAppDemoCall: interestedInAppDemo,
	// 	},
	// };
}

enum BuyerType {
	OWNER = 'Owner',
	OPERATOR = 'Operator',
	HELPER = 'Helper',
	OFFICESTAFF = 'Office Staff',
	OTHER = 'Other',
}

enum PurchaseMode {
	OFFLINE = 'Offline',
	ONLINE = 'Online',
	WHATSAPP = 'WhatsApp',
	PHONECALL = 'Phone call',
	OTHER = 'Other',
}

enum PurchaseFrequency {
	MONTHLY = 'Monthly',
	QUARTERLY = 'Quarterly',
	AS_NEEDED = 'As needed',
	RARELY = 'Rarely',
}

enum PlansToBuySell {
	YES = 'Yes',
	NO = 'No',
	MAYBE = 'Maybe',
}

enum ServiceChannel {
	ONSITE = 'On-site',
	WORKSHOP = 'Workshop',
	CALL = 'Call',
	WHATSAPP = 'WhatsApp',
	ONLINE = 'Online',
}

enum PartsUsagePreference {
	GENUINE = 'Genuine',
	AFTERMARKET = 'Aftermarket',
	BOTH = 'Both',
	NOTSURE = 'Not sure',
}

enum ContactTime {
	MORNING = 'Morning',
	AFTERNOON = 'Afternoon',
	EVENING = 'Evening',
	ANYTIME = 'Any time',
}

enum DeliveryAvailability {
	WEEKDAYS = 'Weekdays',
	WEEKENDS = 'Weekends',
	ANYTIME = 'Anytime',
	BYCALL = 'By call',
}

enum DigitalUsage {
	YES = 'Yes',
	NO = 'No',
	SOMETIMES = 'Sometimes',
}

enum PreferredLanguage {
	ENGLISH = 'English',
	HINDI = 'Hindi',
	KANNADA = 'Kannada',
	// add other languages here as needed
}

enum AgeGroup {
	UNDER_25 = '<25',
	TWENTY_FIVE_THIRTY_FIVE = '25-35',
	THIRTY_SIX_FORTY_FIVE = '36-45',
	FOURTY_SIX_FIFTY_FIVE = '46-55',
	ABOVE_FIFTY_SIX = '56+',
}

export const BuyerTypeOptions = [
	{ id: BuyerType.OWNER, value: BuyerType.OWNER },
	{ id: BuyerType.OPERATOR, value: BuyerType.OPERATOR },
	{ id: BuyerType.HELPER, value: BuyerType.HELPER },
	{ id: BuyerType.OFFICESTAFF, value: BuyerType.OFFICESTAFF },
	{ id: BuyerType.OTHER, value: BuyerType.OTHER },
];

export const PurchaseModeOptions = [
	{ id: PurchaseMode.OFFLINE, value: PurchaseMode.OFFLINE },
	{ id: PurchaseMode.ONLINE, value: PurchaseMode.ONLINE },
	{ id: PurchaseMode.WHATSAPP, value: PurchaseMode.WHATSAPP },
	{ id: PurchaseMode.PHONECALL, value: PurchaseMode.PHONECALL },
	{ id: PurchaseMode.OTHER, value: PurchaseMode.OTHER },
];

export const AgeGroupOptions = [
	{ id: AgeGroup.UNDER_25, value: AgeGroup.UNDER_25 },
	{ id: AgeGroup.TWENTY_FIVE_THIRTY_FIVE, value: AgeGroup.TWENTY_FIVE_THIRTY_FIVE },
	{ id: AgeGroup.THIRTY_SIX_FORTY_FIVE, value: AgeGroup.THIRTY_SIX_FORTY_FIVE },
	{ id: AgeGroup.FOURTY_SIX_FIFTY_FIVE, value: AgeGroup.FOURTY_SIX_FIFTY_FIVE },
	{ id: AgeGroup.ABOVE_FIFTY_SIX, value: AgeGroup.ABOVE_FIFTY_SIX },
];

export const PurchaseFrequencyOptions = [
	{ id: PurchaseFrequency.MONTHLY, value: PurchaseFrequency.MONTHLY },
	{ id: PurchaseFrequency.QUARTERLY, value: PurchaseFrequency.QUARTERLY },
	{ id: PurchaseFrequency.AS_NEEDED, value: PurchaseFrequency.AS_NEEDED },
	{ id: PurchaseFrequency.RARELY, value: PurchaseFrequency.RARELY },
];

export const PlansToBuySellOptions = [
	{ id: PlansToBuySell.YES, value: PlansToBuySell.YES },
	{ id: PlansToBuySell.NO, value: PlansToBuySell.NO },
	{ id: PlansToBuySell.MAYBE, value: PlansToBuySell.MAYBE },
];

export const ServiceChannelOptions = [
	{ id: ServiceChannel.ONSITE, value: ServiceChannel.ONSITE },
	{ id: ServiceChannel.WORKSHOP, value: ServiceChannel.WORKSHOP },
	{ id: ServiceChannel.CALL, value: ServiceChannel.CALL },
	{ id: ServiceChannel.WHATSAPP, value: ServiceChannel.WHATSAPP },
	{ id: ServiceChannel.ONLINE, value: ServiceChannel.ONLINE },
];

export const PartsUsagePreferenceOptions = [
	{ id: PartsUsagePreference.GENUINE, value: PartsUsagePreference.GENUINE },
	{ id: PartsUsagePreference.AFTERMARKET, value: PartsUsagePreference.AFTERMARKET },
	{ id: PartsUsagePreference.BOTH, value: PartsUsagePreference.BOTH },
	{ id: PartsUsagePreference.NOTSURE, value: PartsUsagePreference.NOTSURE },
];

export const ContactTimeOptions = [
	{ id: ContactTime.MORNING, value: ContactTime.MORNING },
	{ id: ContactTime.AFTERNOON, value: ContactTime.AFTERNOON },
	{ id: ContactTime.EVENING, value: ContactTime.EVENING },
	{ id: ContactTime.ANYTIME, value: ContactTime.ANYTIME },
];

export const DeliveryAvailabilityOptions = [
	{ id: DeliveryAvailability.WEEKDAYS, value: DeliveryAvailability.WEEKDAYS },
	{ id: DeliveryAvailability.WEEKENDS, value: DeliveryAvailability.WEEKENDS },
	{ id: DeliveryAvailability.ANYTIME, value: DeliveryAvailability.ANYTIME },
	{ id: DeliveryAvailability.BYCALL, value: DeliveryAvailability.BYCALL },
];

export const DigitalUsageOptions = [
	{ id: DigitalUsage.YES, value: DigitalUsage.YES },
	{ id: DigitalUsage.NO, value: DigitalUsage.NO },
	{ id: DigitalUsage.SOMETIMES, value: DigitalUsage.SOMETIMES },
];

export const PreferredLanguageOptions = [
	{ id: PreferredLanguage.ENGLISH, value: PreferredLanguage.ENGLISH },
	{ id: PreferredLanguage.HINDI, value: PreferredLanguage.HINDI },
	{ id: PreferredLanguage.KANNADA, value: PreferredLanguage.KANNADA },
];

export const BooleanOptions = [
	{ id: 'true', value: 'Yes' },
	{ id: 'false', value: 'No' },
];
